import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: '/',
    name: 'company',
    component: () => import('../views/company.vue')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('../views/product.vue')
  }, 
  {
    path: '/examp',
    name: 'examp',
    component: () => import('../views/examp.vue')
  }, {
    path: '/case',
    name: 'case',
    component: () => import('../views/resource.vue'),
    props: route => ({ item: route.query.item }) // 将查询参数作为 prop 传递给组件
  }, {
    path: '/r_Contain',
    name: 'r_Contain',
    component: () => import('../views/r_Contain.vue')
  }, {
    path: '/welfare',
    name: 'welfare',
    component: () => import('../views/welfare.vue'),
    props: route => ({ item: route.query.item }) // 将查询参数作为 prop 传递给组件
  }, {
    path: '/w_Contain',
    name: 'w_Contain',
    component: () => import('../views/w_Contain.vue')
  }, {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/AboutView.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 如果有历史记录的位置（例如后退、前进）
      return savedPosition;
    } else {
      // 否则跳转时滚动到页面顶部
      return { x: 0, y: 0, behavior: 'smooth' };
    }
  }
})

export default router
